import React from 'react';
import EventsFormContainer from '../../../../Containers/AdminContainer/Events/EventsForm';
const EventsFormScreen = () => {
  return <EventsFormContainer />;
};

export default EventsFormScreen;
